// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingHOC_loader__2QtsK"};